import { defineComponent as t, openBlock as r, createBlock as n, normalizeProps as a, guardReactiveProps as p, withCtx as l, renderSlot as c, createElementVNode as i } from "vue";
import s from "../CdrIcon.vue.mjs";
const m = /* @__PURE__ */ i("path", {
  role: "presentation",
  d: "M12 2a8 8 0 018 8c0 2.81-2.428 6.713-7.284 11.698a1.006 1.006 0 01-1.432 0C6.428 16.713 4 12.811 4 10a8 8 0 018-8zm0 6.5a1.5 1.5 0 100 3 1.5 1.5 0 000-3z"
}, null, -1), _ = /* @__PURE__ */ t({
  name: "LocationPinFill",
  __name: "location-pin-fill",
  props: {
    props: {
      type: Object
    }
  },
  setup(e) {
    return (o, d) => (r(), n(s, a(p(e.props)), {
      default: l(() => [c(o.$slots, "default"), m]),
      _: 3
    }, 16));
  }
});
export {
  _ as default
};
